import { render, staticRenderFns } from "./myAskLeaveSp.vue?vue&type=template&id=172fc1a3&"
import script from "./myAskLeaveSp.vue?vue&type=script&lang=js&"
export * from "./myAskLeaveSp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports